import { render } from "./CutPaletteColorView.vue?vue&type=template&id=42b93274&scoped=true&ts=true"
import script from "./CutPaletteColorView.vue?vue&type=script&lang=ts"
export * from "./CutPaletteColorView.vue?vue&type=script&lang=ts"

import "./CutPaletteColorView.vue?vue&type=style&index=0&id=42b93274&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b93274"]])

export default __exports__